// @ vendors
const { Promise } = require('es6-promise');
// @ actions
const notification = require('actions/notifications');
const signaturePatternActions = require('actions/signaturePattern');
// @ commons
const apiURLBuilder = require('core/apiURLBuilder');
const { APIGet, APIPost } = require('utilities/APIRequestHelper');
const { formatText, getLanguage } = require('core/i18n').i18n;
// @ constants
const actionTypes = require('constants/actionTypes');
const { REGENERATE_SIGNATURE_INIT_ID, REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE } = require('constants/index');
import { KEYS_SIGNATURE_EVENT_TAG, KEYS_SIGNATURE_CATEGORY_ERROR } from 'constants/tagging'

const setSignatureKeyInProgress = () => ({
    type: actionTypes.SET_KEY_SIGNATURE_CHANGE_REQUEST
});

const setSignatureKeySuccess = () => ({
    type: actionTypes.SET_KEY_SIGNATURE_CHANGE_SUCCESS
});

const setSignatureKeyFailure = (error) => ({
    type: actionTypes.SET_KEY_SIGNATURE_CHANGE_FAILURE,
    payload: {
        error
    }
});

const reset = () => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_RESET
});

const setWillLeave = () => ({
     type: actionTypes.KEY_SIGNATURE_CHANGE_WILL_LEAVE
 });
 
const requestBiocatchScoreFailure = () => ({
    type:actionTypes.FETCH_BIOCATCH_SCORE_FAILURE,
});

const requestBiocatchScoreInProgress = () => ({
    type: actionTypes.FETCH_BIOCATCH_SCORE_REQUEST,
});

const requestBiocatchScoreSuccess = () => ({
    type: actionTypes.FETCH_BIOCATCH_SCORE_SUCCESS,
});

const requestSignatureKeyDataInProgress = () => ({
    type: actionTypes.FETCH_KEY_SIGNATURE_DATA_REQUEST
});

const requestSignatureKeyDataSuccess = (data) => ({
    type: actionTypes.FETCH_KEY_SIGNATURE_DATA_SUCCESS,
    payload: {
        cmcContract: {
            lastName: data.contratoCmc.apellido,
            secondLastName: data.contratoCmc.apellido2,
            contract: {
                contractNumber: data.contratoCmc.contrato.numerodecontrato,
                product: data.contratoCmc.contrato.producto
            },
            dateOfBirth: data.contratoCmc.fechaNacimiento,
            name: data.contratoCmc.nombre,
            organizationName: data.contratoCmc.nombreOrganizacion,
            uid: data.contratoCmc.uid
        }
    }
});

const requestSignatureKeyDataFailure = (error) => ({
    type: actionTypes.FETCH_KEY_SIGNATURE_DATA_FAILURE,
    payload: {
        error
    }
});

const setField = (inputField, data) => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_SET_FIELD,
    payload: {
        inputField,
        data
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const validateStep = (step) => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_VALIDATE_STEP,
    payload: {
        step
    }
});

const setSignatureKey = (dispatch, data, biocatchLowScore = false) =>
    new Promise(() => {
        const requestData = {
            ...(biocatchLowScore 
                && {
                    header: { version: 2 }, 
                }
            ),
            query: data
        };

        dispatch(setSignatureKeyInProgress());

        APIPost(dispatch, apiURLBuilder.getURL('signatureKeyChange'), requestData).then(
            () =>  {dispatch(setSignatureKeySuccess())},
            () => {
                const message = formatText('profileKeys-editFailure');
                dispatch(notification.error({message}, {voice: message}));
                dispatch(setSignatureKeyFailure(data));
            }
        );

    });

const updateFirstField = (value, position) => ({
    type: actionTypes.KEY_SIGNATURE_UPDATE_FIRST_FIELD,
    payload: {
        firstInput: {
            value,
            position
        }
    }
});

const updateSecondField = (value, position) => ({
    type: actionTypes.KEY_SIGNATURE_UPDATE_SECOND_FIELD,
    payload: {
        secondInput: {
            value,
            position
        }
    }
});

const postChange = () => (dispatch, getState) => {
    const callback = (dispatch, getState, dataToken) => {
        const myProfileKeysSignature = getState().myProfileKeysSignature;
        const step = myProfileKeysSignature.get('steps').get('0');
        const biocatchLowScore = myProfileKeysSignature.get('biocatchScore') === REGENERATE_SIGNATURE_LOW_BIOCATCH_SCORE;
        const data = {
            dataToken: dataToken,
            confirmFirma: step.get('firstInput').toJS().toString().replace(/,/g, ''),
            nuevaFirma: step.get('secondInput').toJS().toString().replace(/,/g, ''),
            uid: myProfileKeysSignature.getIn(['cmcContract','uid'])
        };
        setSignatureKey(dispatch, data, biocatchLowScore);
    };
    const myProfileKeysSignature = getState().myProfileKeysSignature;
    const isAlreadyFetching = myProfileKeysSignature.get('isFetching');
    const hasError = !!myProfileKeysSignature.get('errorReceived');

    if (!isAlreadyFetching && !hasError){
        new Promise(function () {
            const tagging = { customEventTag: KEYS_SIGNATURE_EVENT_TAG, customCategoryError: KEYS_SIGNATURE_CATEGORY_ERROR }
            signaturePatternActions.validateAndExecute(dispatch, getState, callback, false, tagging);
        })
    }

};

const cancel = () => (dispatch) => {
  const message = formatText('signatureEdit-toasterMessage');
  dispatch(notification.error({message}, {voice: message}));
};

const getBiocatchScore = () => (dispatch) => {
    dispatch(requestBiocatchScoreInProgress());
    const query = {};
    return APIPost(
        dispatch,
        apiURLBuilder.getURL("signaturePatternRequestConfig", { id: REGENERATE_SIGNATURE_INIT_ID, language: getLanguage().toLowerCase() }),
        {
            query,
            isFullResponse: true
        }
    ).then(response => {
        if (response.statusCode === 200) {
            dispatch(requestBiocatchScoreSuccess());
        }
        else {
            dispatch(requestBiocatchScoreFailure());
        }
    }).catch(() => {
        dispatch(requestBiocatchScoreFailure());
    });
};

const requestSignatureKeyData = () => (dispatch, getState) => {
    const isAlreadyFetching = getState().myProfileKeysSignature.get('isFetching');

    if (!isAlreadyFetching) {
        return new Promise(() => {
            const requestData = {};

            dispatch(requestSignatureKeyDataInProgress());
            APIGet(dispatch, apiURLBuilder.getURL('requestAccessKeyData'), requestData).then(
                response => dispatch(requestSignatureKeyDataSuccess(response)),
                error => dispatch(requestSignatureKeyDataFailure(error))
            );
        });
    }
};

const retryProccess = () => ({
    type: actionTypes.KEY_SIGNATURE_CHANGE_RETRY_PROCCESS
});


module.exports = {
    cancel,
    retryProccess,
    getBiocatchScore,
    postChange,
    reset,
    requestSignatureKeyData,
    setField,
    setVisibleStep,
    setWillCancel,
    setWillLeave,
    validateStep,
    updateFirstField,
    updateSecondField

};
